import { getIsoDateFormat } from "./dateTimeFormatter";
import { isLWOPTOWOPRequest } from "./timeOffRequestUtils";

export function buildTimeOffRequestEventPayload(status, data, userSession) {
  let timeOffRequestPayload = {
    action: "addTimeOffRequestEvent",
    modifiedByEid: userSession.eid,
    modifiedByFirstName: userSession.firstName,
    modifiedByLastName: userSession.lastName,
    timeOffRequestStatus: status,
    station: data.station,
    workgroup: data.workgroup,
    requestingEmployeeId: data.empId,
    requestingEmployeeFirstName: data.empFirstName,
    requestingEmployeeLastName: data.empLastName,
    requestingEmployeeWorkgroup: data.empWorkgroup,
    cannedReason: data.cannedReason ? data.cannedReason : "",
    reasonComments: data.reasonComments ? data.reasonComments : "",
    flags: {
      isAdditionalApproved: data.isAdditionalApproved ? data.isAdditionalApproved : false,
      isReinstated: data.isReinstated ? data.isReinstated : false,
      isAdminCreated: data.isAdminCreated ? data.isAdminCreated : false,
    },
    requestingShifts: data.requestingShifts.map((requestingShift) => {
      let currentShift = {
        timeOffRequestType: requestingShift.timeOffRequestType,
        shiftStart: requestingShift.shiftStart,
        shiftStartHour:
          requestingShift.shiftStartHour || requestingShift.shiftStartHour === 0
            ? requestingShift.shiftStartHour
            : requestingShift.shiftStart.hour, // If no shiftStartHour is supplied we can assume the shiftStart field is a Luxon DateTime
        shiftStartMinute:
          requestingShift.shiftStartMinute || requestingShift.shiftStartMinute === 0
            ? requestingShift.shiftStartMinute
            : requestingShift.shiftStart.minute,
        shiftEnd: requestingShift.shiftEnd,
        shiftEndHour:
          requestingShift.shiftEndHour || requestingShift.shiftEndHour === 0
            ? requestingShift.shiftEndHour
            : requestingShift.shiftEnd.hour,
        shiftEndMinute:
          requestingShift.shiftEndMinute || requestingShift.shiftEndMinute === 0
            ? requestingShift.shiftEndMinute
            : requestingShift.shiftEnd.minute,
      };
      if (isLWOPTOWOPRequest(requestingShift.timeOffRequestType)) {
        currentShift.preferredWOPStart = requestingShift.preferredWOPStart;
        currentShift.preferredWOPEnd = requestingShift.preferredWOPEnd;
        currentShift.wopASAP = requestingShift.wopASAP;
        currentShift.phoneNumber = requestingShift.phoneNumber;
        currentShift = {
          ...currentShift,
          ...(requestingShift.approvedWOPStart ? { approvedWOPStart: requestingShift.approvedWOPStart } : {}),
          ...(requestingShift.approvedWOPEnd ? { approvedWOPEnd: requestingShift.approvedWOPEnd } : {}),
        };
      }
      return currentShift;
    }),
  };

  if (data.torId) {
    // An existing time off request has a new event
    // Make sure to add critical id's that will tie this event to the time off request
    timeOffRequestPayload.torId = data.torId;
    timeOffRequestPayload.submissionId = data.submissionId;
    timeOffRequestPayload.referenceNumber = data.referenceNumber;
  }

  return timeOffRequestPayload;
}

export function buildWOPFreezeEventPayload(date, startFreeze, workgroup, wopType, station, employeeData) {
  return {
    date: getIsoDateFormat(date),
    workgroup: workgroup,
    wopType: wopType,
    station: station,
    startFreeze: startFreeze,
    modifiedBy: {
      eid: employeeData.eid,
      firstName: employeeData.firstName,
      lastName: employeeData.lastName,
    },
  };
}
